// SSE Connection Status
export const SSE_CONNECTION_STATUS = 'SSE_CONNECTION_STATUS';

// Notification Actions
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

// Reminder Actions
export const UPDATE_REMINDER_DATA = 'UPDATE_REMINDER_DATA';
export const REMINDER_NEW = 'REMINDER_NEW';
export const REMINDER_DISMISSED = 'REMINDER_DISMISSED';

// Mail Actions
export const UPDATE_MAIL_DATA = 'UPDATE_MAIL_DATA';
export const MAIL_NEW = 'MAIL_NEW';
export const MAIL_UPDATED = 'MAIL_UPDATED';


